import { IDependentItem } from './idependent-item';

export class DependentItem implements IDependentItem {
  DependentItemId: number;
  DependentItemNumber: number;
  DependentItemName: string;
  ProjectSubTypeId: number;
  Quantity: number;
  IsModified: boolean;
  IsNew: boolean;
}